/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Post_Purchase_TitleInputs */

const en_meta_post_purchase_title = /** @type {(inputs: Meta_Post_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Your Account | Start Your Journey with Listening.com Today`)
};

const es_meta_post_purchase_title = /** @type {(inputs: Meta_Post_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu cuenta | Comienza tu recorrido con Listening.com hoy`)
};

/**
* | output |
* | --- |
* | "Create Your Account \| Start Your Journey with Listening.com Today" |
*
* @param {Meta_Post_Purchase_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_post_purchase_title = /** @type {((inputs?: Meta_Post_Purchase_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Post_Purchase_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_post_purchase_title(inputs)
	return en_meta_post_purchase_title(inputs)
});